export default __webpack_public_path__ + "static/media/spid-idp-namirialid.d787f58d.svg";